//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import PaymentRequired from "../pages/PaymentRequired";




/**
 * Top level application router
 *
 * @returns {JSX.Element}
 */
const Router = () => {
  return (
    <Routes>
      <Route path={"/"} element={< PaymentRequired/>} />
    </Routes>
  );
};

export default Router;
